export default __webpack_public_path__ + "static/media/logo-pinterest.1d532d1c.svg";